"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SendTemplateEmail {
    static getAttributeTypeMap() {
        return SendTemplateEmail.attributeTypeMap;
    }
}
SendTemplateEmail.discriminator = undefined;
SendTemplateEmail.attributeTypeMap = [
    {
        "name": "messageId",
        "baseName": "messageId",
        "type": "string"
    }
];
exports.SendTemplateEmail = SendTemplateEmail;
//# sourceMappingURL=sendTemplateEmail.js.map